(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[20238],{

/***/ 343029:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/p/[slug]",
      function () {
        return __webpack_require__(31269);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 632843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68706);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(685172);


const ShopFrontKitLoadable = __webpack_require__.e(/* import() */ 22765).then(__webpack_require__.t.bind(__webpack_require__, 722765, 23));
const PaymentKitLoadable = __webpack_require__.e(/* import() */ 25098).then(__webpack_require__.bind(__webpack_require__, 225098));
const waitForPaymentStatus = "WAITING_FOR_PAYMENT_CONFIRMATION";
const terraHelper = {
    isAvailable: _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable,
    getLoyaltyConfig: ()=>{
        return _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].loyalty */ .Z.loyalty().getLoyaltyConfig();
    },
    handleBackOr: async (callback)=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const ShopFrontKit = (await ShopFrontKitLoadable).default;
            const shouldHandleBack = await ShopFrontKit.shouldHandleBack();
            if (shouldHandleBack) {
                ShopFrontKit.handleBack();
            } else {
                callback === null || callback === void 0 ? void 0 : callback();
            }
        } else {
            callback === null || callback === void 0 ? void 0 : callback();
        }
    },
    getScreenConfig: async ()=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const ShopFrontKit = (await ShopFrontKitLoadable).default;
            return ShopFrontKit.getScreenConfig();
        } else {
            return Promise.resolve(undefined);
        }
    },
    finish: ()=>_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].finish */ .Z.finish(),
    payForOrder: (param)=>{
        let { order , customerProfileId , orderService  } = param;
        return terraHelper.pay({
            orderCode: order.code,
            orderId: order.id,
            amount: order.remainPayment,
            customerProfileId,
            orderService
        });
    },
    pay: async (param)=>{
        let { orderCode , orderId , amount , customerProfileId , orderService  } = param;
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const { default: PaymentKit , PaymentRequestBuilder  } = await PaymentKitLoadable;
            const paymentRequestBuilder = new PaymentRequestBuilder();
            const { MainMethodType  } = await __webpack_require__.e(/* import() */ 91621).then(__webpack_require__.bind(__webpack_require__, 891621));
            paymentRequestBuilder.setOrder({
                orderCode: orderCode,
                orderAmount: amount
            }).setPaymentMethods({
                mainMethod: {
                    method: MainMethodType.All,
                    amount
                },
                totalAmount: amount
            }).setOptions({
                shouldShowPaymentResultScreen: true
            });
            return PaymentKit.payForOrder(paymentRequestBuilder.build()).then((result)=>{
                switch(result.resultCode){
                    case "succeeded":
                        window.location.href = "/account/orders/".concat(orderId);
                        break;
                    case "canceled":
                    case "failed":
                        orderService.getOrder({
                            orderId,
                            customerId: customerProfileId
                        }).then((order)=>{
                            if (order.status === waitForPaymentStatus) {
                                window.location.href = "/confirm-payment/".concat(orderId);
                            } else {
                                window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                            }
                        }).catch(()=>{
                            // this is a fallback in case the order is not synced with cov
                            window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                        });
                        break;
                }
            });
        }
        return Promise.resolve();
    },
    observeOpenBuyNow: (params, handlers)=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].common */ .Z.common().openBuyNow(params).subscribe(handlers);
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (terraHelper);


/***/ }),

/***/ 752627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PageBuilderDesktop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(665207);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626650);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127795);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const PageBuilderDesktop = (props)=>{
    var ref;
    const { pbMetaData , name  } = props;
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_2__/* .HeadSection */ .I, {
                title: pbMetaData.metaTitle || name,
                metaTitle: pbMetaData.metaTitle,
                description: pbMetaData.metaDescription,
                canonical: pbMetaData.canonical,
                noindex: pbMetaData.noIndex,
                keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.join(","),
                image: pbMetaData.metaImage,
                schemaPage: pbMetaData.jsonLd
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(contexts__WEBPACK_IMPORTED_MODULE_3__/* .HamperProvider */ .R, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page__WEBPACK_IMPORTED_MODULE_4__/* .PbPage */ .f, _objectSpreadProps(_objectSpread({}, props), {
                    page: query.slug
                }))
            })
        ]
    });
};


/***/ }),

/***/ 31269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ p_slug_; }
});

// EXTERNAL MODULE: ./modules/page-builder/desktop/PageBuilder.tsx
var PageBuilder = __webpack_require__(752627);
;// CONCATENATED MODULE: ./tenants/_template/desktop/p/[slug].tsx

const getServerSideProps = (context)=>getPbPageServerSideProps(context, context.query.slug);
/* harmony default export */ var _slug_ = (PageBuilder/* PageBuilderDesktop */.K);

;// CONCATENATED MODULE: ./pages/default/desktop/p/[slug].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var p_slug_ = (_slug_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [93712,1393,96464,25700,75803,33249,12512,4857,50424,46921,88568,12583,59063,97736,70818,72992,71991,81826,97115,60342,48019,81430,27953,19303,20493,54615,76414,75566,80300,98459,68310,31622,49354,49774,92888,40179], function() { return __webpack_exec__(343029); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);